import { BLACKBAUD_CLIENT_ID } from './constants';

/** Where the customer adds the Feathr application to their Blackbaud account. */
export const BLACKBAUD_MARKETPLACE_URL = `https://app.blackbaud.com/marketplace/applications/${BLACKBAUD_CLIENT_ID}?action=getstarted`;

/** The extender route that finishes the OAuth flow (`BlackbaudOAuthCallback`). */
export const BLACKBAUD_OAUTH_CALLBACK_PATH = '/oauth/blackbaud';

const BLACKBAUD_AUTHORIZE_URL = 'https://app.blackbaud.com/oauth/authorize';

/** The OAuth redirect URI. Blackbaud and the authenticate call must get the same value. */
export function getBlackbaudRedirectUri(origin: string): string {
  return `${origin}${BLACKBAUD_OAUTH_CALLBACK_PATH}`;
}

/**
 * The Blackbaud OAuth authorize URL. `returnPath` goes in `state` as base64, and the callback sends
 * the customer back to it.
 */
export function getBlackbaudAuthorizeUrl(origin: string, returnPath: string): string {
  const url = new URL(BLACKBAUD_AUTHORIZE_URL);
  url.searchParams.set('client_id', BLACKBAUD_CLIENT_ID);
  url.searchParams.set('response_type', 'code');
  url.searchParams.set('redirect_uri', getBlackbaudRedirectUri(origin));
  url.searchParams.set('state', btoa(returnPath));
  return url.toString();
}
